import jQuery from 'jquery'
import { Modal, Popover } from 'bootstrap'

jQuery(function () {
  if (jQuery('#petition_form').length > 0) {
    const form = jQuery('#petition_form')
    const displayEditConfirmation = form.data('display-edit-confirmation')

    // If there are input fields with popovers, show the first one on page load.
    // The popovers will have already been initialized in popovers.js, so we're not
    // checking for rel=popover or creating any popovers, just opening one if it exists.
    const firstField = document.querySelector('#petition_form input[type=text]:enabled')
    if (firstField) {
      const popover = Popover.getInstance(firstField)
      if (popover) {
        popover.show()
      }
    }

    if (displayEditConfirmation) {
      jQuery('#petition-save-button .submit-button').on('click', () => {
        document.querySelectorAll('.edit-confirmation-modal').forEach((el) => {
          Modal.getOrCreateInstance(el).show()
        })
        return false
      })
    }

    jQuery('#edit-confirmation-save').on('click', () => {
      // Extract the message
      const element = jQuery('#modal_edit_moderation_message')
      const message = element.val()

      // Remove errors, if any exist.
      jQuery('#modal_edit_moderation_message').removeClass('is-invalid')

      let errorElement = jQuery('.edit-confirmation-modal').find('span.help-inline')
      if (errorElement != null) {
        errorElement.remove()
      }

      if (message.length > 0) {
        // set hidden field for form submission.
        jQuery('#petition_edit_moderation_message').val(message)
        jQuery('#petition_form').submit()
        return true
      } else {
        jQuery('#modal_edit_moderation_message').addClass('is-invalid')
        errorElement = jQuery('<span/>', { class: 'help-inline', text: 'can\'t be blank' })
        const inputLabel = jQuery(`label[for=${element.attr('id')}]`)
        errorElement.insertAfter(inputLabel)
        return false
      }
    })
  }
})
